export default __webpack_public_path__ + "static/media/zawodniczka2.ee2127d2.png";